import { render, staticRenderFns } from "./KnowledgeCard.vue?vue&type=template&id=d4f694ce&"
import script from "./KnowledgeCard.vue?vue&type=script&lang=js&"
export * from "./KnowledgeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4f694ce')) {
      api.createRecord('d4f694ce', component.options)
    } else {
      api.reload('d4f694ce', component.options)
    }
    module.hot.accept("./KnowledgeCard.vue?vue&type=template&id=d4f694ce&", function () {
      api.rerender('d4f694ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/condoMngt/component/KnowledgeCard.vue"
export default component.exports